import type { ReactNode } from "react";

export interface PurchaseConfirmationViewProps {
  /** The wired routed modal + purchase success modal supplied by the container. */
  children: ReactNode;
}

/**
 * Presentational shell for the paid purchase confirmation modal route. This page is a
 * thin wrapper: all wiring (Head, routed modal, purchase success modal) lives in the
 * container (`confirmation.tsx`) and is passed in as `children`; this simply renders it.
 */
export function PurchaseConfirmationView({ children }: PurchaseConfirmationViewProps) {
  return <>{children}</>;
}
